import {riskUnitsCache$} from '@/ras/ras';
import {toUiMsg$} from '@/ui';

import type {RiskUnit} from '@/types/ws';

export interface URas {
  type: 'risk-unit';
  data: Map<string, RiskUnit>;
}

export function subscribeRas() {
  riskUnitsCache$.subscribe((data) => toUiMsg$.next({type: 'risk-unit', data}));
}
